// @flow

import * as React from 'react';
import { Col, Input, Row } from 'antd'

type Props = {
  searchTerm: string,
  onChangeSearch: Function,
}

export default class extends React.PureComponent<Props> {

  render() {

    const {
      searchTerm,
      onChangeSearch,
    } = this.props;

    return (

      <Row style={{ marginBottom: 15 }}>

        <Col span={12}>

          <Input.Search
            style={{ width: 250 }}
            placeholder="Search"
            onChange={onChangeSearch}
            value={searchTerm}
          />

        </Col>

      </Row>
    )
  }
}
